var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-3"},[_c('div',[_vm._v("Action: "+_vm._s(_vm.description))]),_vm._v(" "),_c('div',[_vm._v("By: "+_vm._s(_vm.activity.causer.name))]),_vm._v(" "),_c('div',[_vm._v("On: "+_vm._s(_vm.momentFormatDateTimeYear(_vm.activity.created_at)))]),_vm._v(" "),_c('v-divider',{staticClass:"my-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }